// extracted by mini-css-extract-plugin
module.exports = {"container":"Modal_container__1SHDb","header":"Modal_header__3GJfM","content":"Modal_content__1EFgw"};